var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"side-list-model",attrs:{"to":_vm.link}},[_c('span',{class:`side-list-li ` + _vm.img},[_vm._t("haveUnread")],2),_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }